var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightSnowShower01 = function SvgLightSnowShower01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.78,
    y1: 168.87,
    x2: 155.38,
    y2: 14.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 45.59,
    y1: 212.41,
    x2: 199.19,
    y2: 57.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 9.96,
    y1: 177,
    x2: 163.56,
    y2: 22.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 56.21,
    y1: 222.97,
    x2: 209.81,
    y2: 68.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 27.09,
    y1: 194.03,
    x2: 180.69,
    y2: 39.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 10.39,
    y1: 177.42,
    x2: 163.99,
    y2: 22.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 37.83,
    y1: 204.69,
    x2: 191.43,
    y2: 50.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 75.6,
    y1: 242.24,
    x2: 229.2,
    y2: 87.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 59.15,
    y1: 225.89,
    x2: 212.75,
    y2: 71.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 76.33,
    y1: 242.97,
    x2: 229.93,
    y2: 88.42,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M146.95,25.93c-2.88,0-5.83.39-8.94,1.19C130.4,10.54,114.14,0,95.78,0,75.45,0,57.63,13.01,51.43,32.38c-.56,1.75.4,3.63,2.16,4.19,1.76.57,3.63-.4,4.18-2.16,5.31-16.6,20.59-27.75,38.01-27.75,15.48,0,29.22,8.77,35.86,22.61-4.57,2.09-7.73,5.17-9.67,7.64-1.14,1.44-.89,3.54.55,4.68.61.48,1.34.71,2.06.71.98,0,1.96-.44,2.62-1.27,1.8-2.29,4.96-5.3,9.8-6.69.02,0,.09-.03.11-.03,3.55-1.16,6.76-1.72,9.83-1.72,17.59,0,31.9,14.31,31.9,31.9s-14.31,31.9-31.9,31.9H45.18c-13.25,0-24.03-10.78-24.03-24.03s10.78-24.03,24.03-24.03c1.96,0,4,.32,6.43,1,3.19.96,6.14,2.69,8.33,4.86.65.65,1.5.97,2.35.97s1.71-.33,2.36-.98c1.3-1.3,1.29-3.41-.01-4.71-2.95-2.94-6.91-5.25-11.13-6.52-.01,0-.02,0-.03,0,0,0-.02-.01-.03-.01-3.05-.86-5.68-1.26-8.27-1.26-16.92,0-30.69,13.77-30.69,30.69s13.77,30.69,30.69,30.69h101.76c21.26,0,38.56-17.3,38.56-38.56,0-21.26-17.3-38.56-38.56-38.56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.41,125.24c-.61-1.07-1.98-1.43-3.05-.82l-6.2,3.58,1.3-4.85c.32-1.19-.39-2.41-1.58-2.73-1.19-.3-2.41.39-2.73,1.58l-2.45,9.16-4.77,2.75c-1.22-1.27-2.78-2.19-4.54-2.62v-5.42l6.7-6.7c.87-.87.87-2.28,0-3.15s-2.28-.87-3.15,0l-3.55,3.55v-7.25c0-1.23-1-2.23-2.23-2.23s-2.23,1-2.23,2.23v7.24l-3.55-3.55c-.87-.87-2.28-.87-3.15,0-.87.87-.87,2.28,0,3.15l6.7,6.7v5.43c-1.76.43-3.33,1.35-4.55,2.62l-4.69-2.71-2.45-9.16c-.32-1.19-1.54-1.89-2.73-1.58-1.19.32-1.89,1.54-1.58,2.73l1.3,4.85-6.28-3.63c-1.06-.62-2.43-.25-3.05.82-.62,1.07-.25,2.43.82,3.05l6.27,3.62-4.85,1.3c-1.19.32-1.89,1.54-1.58,2.73.27,1,1.17,1.65,2.15,1.65.19,0,.38-.02.58-.08l9.15-2.45,4.72,2.72c-.25.84-.42,1.71-.42,2.62s.17,1.77.41,2.61l-4.7,2.72-9.16-2.45c-1.19-.3-2.41.39-2.73,1.58-.32,1.19.39,2.41,1.58,2.73l4.85,1.3-6.28,3.63c-1.07.62-1.43,1.98-.82,3.05.62,1.07,1.98,1.43,3.05.82l6.27-3.62-1.3,4.85c-.32,1.19.39,2.41,1.58,2.73,1.22.32,2.42-.41,2.73-1.58l2.45-9.16,4.69-2.71c1.22,1.27,2.79,2.19,4.55,2.62v5.5l-6.7,6.7c-.87.87-.87,2.28,0,3.15.87.87,2.28.87,3.15,0l3.55-3.55v7.17c0,1.23,1,2.23,2.23,2.23s2.23-1,2.23-2.23v-7.16l3.55,3.55c.87.87,2.28.87,3.15,0,.87-.87.87-2.28,0-3.15l-6.7-6.7v-5.51c1.76-.43,3.33-1.35,4.55-2.62l4.75,2.74,2.45,9.16c.31,1.16,1.51,1.9,2.73,1.58,1.19-.32,1.89-1.54,1.58-2.73l-1.3-4.85,6.21,3.59c1.06.62,2.43.25,3.05-.82.62-1.07.25-2.43-.82-3.05l-6.2-3.58,4.85-1.3c1.19-.32,1.89-1.54,1.58-2.73s-1.54-1.89-2.73-1.58l-9.16,2.45-4.78-2.76c.24-.83.41-1.7.41-2.61s-.17-1.78-.42-2.62l4.78-2.76,9.16,2.45c.19.05.39.08.58.08.98,0,1.89-.66,2.15-1.65.32-1.19-.39-2.41-1.58-2.73l-4.85-1.3,6.21-3.59c1.07-.62,1.43-1.98.82-3.05M117.15,145.34c-2.72,0-4.93-2.21-4.93-4.94s2.21-4.95,4.93-4.95,4.95,2.22,4.95,4.95-2.22,4.94-4.95,4.94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M62.95,116.53c-2.61-2.61-6.86-2.61-9.46,0l-7.21,7.21c-2.61,2.61-2.62,6.85,0,9.46l7.19,7.19c2.61,2.61,6.85,2.61,9.46,0l7.21-7.21c2.61-2.61,2.61-6.85,0-9.46l-7.19-7.19ZM66.99,130.03l-7.21,7.21c-.87.87-2.28.87-3.16,0l-7.19-7.19c-.87-.87-.87-2.28,0-3.15l7.21-7.21c.87-.87,2.28-.87,3.15,0l7.19,7.19c.87.87.87,2.28,0,3.15"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.58,174.18c-2.61-2.61-6.85-2.61-9.46,0l-7.21,7.21c-2.61,2.61-2.61,6.85,0,9.46l7.19,7.19c2.61,2.61,6.85,2.61,9.46,0l7.21-7.21h0c2.61-2.61,2.61-6.85,0-9.46l-7.19-7.19ZM101.62,187.68l-7.21,7.21c-.87.87-2.29.87-3.16,0l-7.19-7.19c-.87-.87-.87-2.28,0-3.15l7.21-7.21c.87-.87,2.28-.87,3.15,0l7.19,7.19c.87.87.87,2.28,0,3.15"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M59.98,160.9h0c-.77-.77-.77-2.01,0-2.77l11.58-11.58c.77-.77,2.01-.77,2.77,0,.77.77.77,2.01,0,2.77l-11.58,11.58c-.77.77-2.01.77-2.77,0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M29.39,158.26h0c-.77-.77-.77-2.01,0-2.77l11.58-11.58c.77-.77,2.01-.77,2.77,0,.77.77.77,2.01,0,2.77l-11.58,11.58c-.77.77-2.01.77-2.77,0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M56.72,185.64h0c-.77-.77-.77-2.01,0-2.77l11.58-11.58c.77-.77,2.01-.77,2.77,0,.77.77.77,2.01,0,2.77l-11.58,11.58c-.77.77-2.01.77-2.77,0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M125.56,191.93h0c-.77-.77-.77-2.01,0-2.77l11.58-11.58c.77-.77,2.01-.77,2.77,0,.77.77.77,2.01,0,2.77l-11.58,11.58c-.77.77-2.01.77-2.77,0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M156.25,128.14h0c-.77-.77-.77-2.01,0-2.77l11.58-11.58c.77-.77,2.01-.77,2.77,0,.77.77.77,2.01,0,2.77l-11.58,11.58c-.77.77-2.01.77-2.77,0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.25,162.51h0c-.77-.77-.77-2.01,0-2.77l11.58-11.58c.77-.77,2.01-.77,2.77,0,.77.77.77,2.01,0,2.77l-11.58,11.58c-.77.77-2.01.77-2.77,0"
  })));
};
export default SvgLightSnowShower01;